<template>
     <ul class="header-tab clearfix">
        <li v-if="showAll" :class="tabClass(null)" @click="onTab(null)">
            <span>全部</span>
        </li>
        <li v-for="(item,index) in tabs" 
            :class="tabClass(item)" 
            @click="onTab(item)" 
            :key="index" >
            <span>
                {{tabDisplayName?item[tabDisplayName]:item}}
            </span>
        </li>
    </ul>
</template>
<script>
export default {
    name:'header-tab',
    props:{
        tabs:{
            type: Array, 
            required: true,
            default: []
        },
        activeProp:{
            type:String, 
            required:false,
            default:''
        },
        tabDisplayName:{
            type:String,
            required:false,
            default:''
        },
        showAll:{
            type:Boolean,
            default:true,
            required:false
        },
        active:{ 
            required:false
        }
    },
    data(){
        return {
            activeTab:''
        }
    },
    created(){
        this.activeTab = this.active
        if(this.showAll && !this.active){
            if(this.tabs && this.tabs.length > 0){
                var first = this.tabs[0]
                if(this.activeProp){
                    this.activeTab = first[this.activeProp]
                } else {
                    this.activeTab = first
                }
            }
        }
    },
    methods:{
        onTab(tabItem){ 
            if(!tabItem){
                this.$emit('onTab',null)
            } else {
                if(this.activeProp){
                    this.$emit('onTab',tabItem[this.activeProp])
                } else {
                    this.$emit('onTab',tabItem)
                }
            }

            
            if(this.activeProp && tabItem){
                this.activeTab = tabItem[this.activeProp]
            } else {
                this.activeTab = tabItem
            }
        },
        tabClass(tabItem){
            let classResult = {
                'active':false
            } 
            if(!tabItem){
                if(!this.activeTab){
                    classResult.active = true
                } else {
                    classResult.active = false
                }
                
                return classResult
            }
            
            if(this.activeProp){                 
                var name = this.activeProp 
                classResult.active = this.activeTab === tabItem[name]
                 

            } else {
                classResult.active = this.activeTab === tabItem                
            }
            return classResult
        }
    }
}
</script>

<style lang="less" scoped>
 

.header-tab {
    background: #fff;
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow-x: auto;
    border: 1px solid #e5e5e5;

    &::-webkit-scrollbar {
      display: none;
      opacity: 0;
    }

    li {
      float: left;
      line-height: 100 / @rem-size;
      padding: 0 30 / @rem-size;
      font-size: 32 / @rem-size;
      color: #333;

      &.active {
        span {
          color: #005fd5;
          border-bottom: 3 / @rem-size solid #005fd5;
        }
      }

      span {
        display: block;
      }
    }
  }
</style>
